import React from "react";
import styled from "styled-components";
import {WerfenFormTextColor} from "../../Constants/ColorChart";

const StyledParagraph = styled.p`
  border: none;
  width: 100%;
  color: ${WerfenFormTextColor};
  padding-left: 5%;
  padding-right: 5%;
  display: inline-block;
  padding-bottom: 2%;
  margin-right: 0;
  font-size: 15px;
`;

const LoginStartSession: React.FC = () => {
    return (
        <div>
            <StyledParagraph>
                You need to start your session while you are online.
                <br/>
                Please, connect to the Internet.
                <br/>
            </StyledParagraph>
        </div>
    );
};

export default LoginStartSession;